import React, { useEffect, useState } from "react";
import { Button, Card, Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import AppUrl from "../../RestApi/AppUrl";
import RestClient from "../../RestApi/RestClient";
import Loader from "../../shared/Loader/Loader";
import WentWrong from "../../shared/WentWrong/WentWrong";
import recentPostCss from "./AllProjects.module.css";
import Slide from "react-reveal/Slide";
import Fade from "react-reveal/Fade";

export default function AllProjects() {
  const [allProjects, setAllProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  useEffect(() => {
    RestClient.GetRequest(AppUrl.AllProjects).then((result) => {
      if (result == null) {
        setError(true);
      } else {
        setAllProjects(result);
        setLoading(false);
      }
    });
  }, []);
  return (
    <>
      {loading && <Loader />}
      <Container className="text-center mt-4">
        {!error ? (
          <Row className="">
            {allProjects.map((allproject, i) => {
              return (
                <Col lg={4} md={6} sm={12}>
                  <Card className={`${recentPostCss.cardContainer} mb-3`}>
                    <Fade top>
                      <Card.Img variant="top" src={allproject.img_one} />
                    </Fade>
                    <Slide right>
                      <Card.Body>
                        <Card.Title className={`${recentPostCss.cardTitle}`}>
                          {allproject.project_name}
                        </Card.Title>
                        <Card.Text className={`${recentPostCss.cardDes}`}>
                          {allproject.project_description}
                        </Card.Text>
                        <Link to={`/projectDetails/${allproject.id}`}>
                          <Button variant="primary">Visit Now</Button>
                        </Link>
                      </Card.Body>
                    </Slide>
                  </Card>
                </Col>
              );
            })}
          </Row>
        ) : (
          <WentWrong />
        )}
      </Container>
    </>
  );
}
